import { render, staticRenderFns } from "./DraggableMenuList.vue?vue&type=template&id=35a4d5fb&scoped=true&"
import script from "./DraggableMenuList.vue?vue&type=script&lang=js&"
export * from "./DraggableMenuList.vue?vue&type=script&lang=js&"
import style0 from "./DraggableMenuList.vue?vue&type=style&index=0&id=35a4d5fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4d5fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressLinear,VRow})
